import {
  EWZSimpleClosureType,
  EWZClosureTypeDeprecated,
  EWZSimpleClosureTypeLane,
  EWZSimpleClosureTypeShoulder,
  EWZSimpleClosureTypeReducedSpeed,
  EWZSimpleClosureTypeLeftTurn,
  EWZSimpleClosureTypeRightTurn,
  EWZSimpleClosureTypeHeightLimit,
} from "mhc-server/dist/interfaces";

import {
  IInputSelectOption,
  IInputSelectGroup,
} from "mhc-ui-components/dist/InputSelect";

import {
  convertEnumKeyToHumanReadable,
  convertEnumToValueLabel,
} from "utils-library/dist/utils";

interface IClosureTypeInputOptions {
  closureTypeGroupedOptions: IInputSelectGroup[];
  closureTypeOptions: IInputSelectOption[];
}

export const getTypeOfClosureInputOptions = (): IClosureTypeInputOptions => {
  return {
    closureTypeGroupedOptions: [
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.LANE_CLOSED, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeLane, {everyWord: true}),
      },
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.SHOULDER_CLOSED, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeShoulder, {everyWord: true}),
      },
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.REDUCED_SPEED, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeReducedSpeed, {everyWord: true}),
      },
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.LEFT_TURN, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeLeftTurn, {everyWord: true}),
      },
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.RIGHT_TURN, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeRightTurn, {everyWord: true}),
      },
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.HEIGHT_LIMIT, true),
        options: convertEnumToValueLabel(EWZSimpleClosureTypeHeightLimit, {everyWord: true}),
      },
    ],
    closureTypeOptions: [
      {
        label: convertEnumKeyToHumanReadable(EWZSimpleClosureType.NONE, true),
        value: EWZSimpleClosureType.NONE,
      },
      ...convertEnumToValueLabel(EWZClosureTypeDeprecated, {everyWord: true}),
    ],
  };
};
